import {useMemo} from 'react';
import {CssBaseline, StyledEngineProvider} from '@mui/material';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import useConfig from "../hooks/theme/useConfig";
import Typography from './typography';
import CustomShadows from './shadows';
import componentsOverride from './overrides';
import Palette from "./palette";

// ==============================|| DEFAULT THEME - MAIN  ||============================== //

export default function ThemeCustomization({children}) {
	const { themeDirection, mode, presetColor, fontFamily, fontFamilySpecial } = useConfig()
	const theme = useMemo(() => Palette(), []);
	const themeTypography = useMemo(() => Typography(), []);
	const themeCustomShadows = useMemo(() => CustomShadows(theme), [theme]);
	
	const themeOptions = useMemo(
		() => ({
			breakpoints: {
				values: {
					xs: 0,
					sm: 660,
					md: 1024,
					lg: 1266,
					xl: 1440
				}
			},
			mixins: {
				toolbar: {
					minHeight: 60,
					paddingTop: 8,
					paddingBottom: 8
				}
			},
			palette: theme.palette,
			customShadows: themeCustomShadows,
			typography: themeTypography,
			spacing: 8,
			shape: {
				borderRadius: 4,
			},
		}),
		[theme.palette, themeCustomShadows, themeTypography]
	);
	
	const themes = createTheme(themeOptions);
	themes.components = componentsOverride(themes);
	
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={themes}>
				<CssBaseline/>
				{children}
			</ThemeProvider>
		</StyledEngineProvider>
	);
}